import { Injector, Injectable } from "@angular/core";
import { cgpAuthentication } from "../../../modules/cgp-authentication";
import { BaseHttpService } from "../../shared/services/base-http.service";
import { HttpParams } from "@angular/common/http";
import { CgpAlertDialogService } from "../../shared/cgp-alert-dialog/cgp-alert-dialog.service";
import { phfInfo } from "../phf/phf.config";
import { mescServicesUrl } from "./config";
import { utilities } from "../../../../src/modules/utility";

export abstract class MescService extends BaseHttpService {
    private readonly tableName: string;
    // Mesc service
    private readonly BASE_URL: string;
    // Module service
    private readonly MODULE_URL: string;

    constructor(
        injector: Injector,
        tableName: string,
    ) {
        super(injector);
        this.tableName = tableName;
        this.BASE_URL = mescServicesUrl[utilities.getEnv()];
        this.MODULE_URL = phfInfo.services[utilities.getEnv()];
    }

    /**
     * 
     */
    read = (path = '', catchError = true): Promise<any> => super.fetch(this.getUrl() + this.tableName + path, catchError);
    /**
     * 
     */
    search = (body: any, path = '', catchError = true, searchParams: HttpParams = null): Promise<any> => {
        return super.post(body, this.getUrl() + this.tableName + path, catchError, searchParams);
    }
    /**
     * 
     */
    save = (obj, isNew: boolean, path = '', catchError = true): Promise<any> => {
        return isNew ? super.post(obj, this.getUrl() + this.tableName + path, catchError) : super.put(obj, this.getUrl() + this.tableName + path, catchError);
    }
    /**
     * 
     */
    uploadExcel = (obj, isNew: boolean, path = '', catchError = true): Promise<any> => super.post_excel(obj, this.getUrl() + this.tableName + path, catchError);
    /**
     * 
     */
    applyThroughput = (obj, isNew: boolean, path = '', catchError = true): Promise<any> => super.put(obj, this.getUrl() + this.tableName + path, catchError);
    /**
     * 
     */
    applyParts = (obj, isNew: boolean, path = '', catchError = true): Promise<any> => super.post_excel(obj, this.getUrl() + this.tableName + path, catchError);
    /**
     * 
     */
    remove = (path: string, catchError = true): Promise<any> => super.delete(this.getUrl() + this.tableName + path, catchError);
    /**
     * 
     */
    export = (body: any, path = '', searchParams: HttpParams = null): Promise<any> => super.download(body, this.getUrl() + this.tableName + path, searchParams);
    /**
     * 
     */
    getCGPUser = (gmin: string, catchError = true): Promise<any> => super.fetch(`${this.getUrl()}common/User/CgpUserByGminGmid?gminGmid=${gmin}`, catchError);
    /**
     * 
     */
    private readonly getCurrentUserGmin = (): string => cgpAuthentication.getUserInfo().gmuniqueidentifier;
    /**
     * 
     */
    private getUrl(): string {
        return this.tableName.toLowerCase().startsWith('common') ? this.BASE_URL : this.MODULE_URL;
    }
}


@Injectable()
export class BaseService extends MescService {
    constructor(injector: Injector) { super(injector, ""); }
}

@Injectable()
export class ModuleService extends MescService {
    constructor(injector: Injector) { super(injector, "common/Module"); }
}

@Injectable()
export class UserService extends MescService {
    constructor(injector: Injector, private readonly cgpAlertDialog: CgpAlertDialogService) {
        super(injector, "common/User");
        this.httpErrorHeader = 'User Error'
    }
}

@Injectable()
export class UserProfileService extends MescService {
    constructor(injector: Injector) { super(injector, "common/User/UserProfile"); }
}

@Injectable()
export class RoleService extends MescService {
    constructor(injector: Injector) { super(injector, "common/Role"); }
}

@Injectable()
export class UserLastLoginDateService extends MescService {
    constructor(injector: Injector) { super(injector, "common/User/LastLoginDate"); }
}
